var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgDashboard = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 14, height: 14, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M6 0v7.3h7.3A6.667 6.667 0 1 1 6 0Zm1.333 0A6.667 6.667 0 0 1 13.3 5.967H7.333V0Z", fill: "#666" }));
export { SvgDashboard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMHY3LjNoNy4zQTYuNjY3IDYuNjY3IDAgMSAxIDYgMFptMS4zMzMgMEE2LjY2NyA2LjY2NyAwIDAgMSAxMy4zIDUuOTY3SDcuMzMzVjBaIiBmaWxsPSIjNjY2Ii8+PC9zdmc+";
